<script>
import axios from 'axios'
import Logo from '@/components/Logo.vue'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card/index.js'
import { Input } from '@/components/ui/input/index.js'
import { Button } from '@/components/ui/button/index.js'
import { Label } from '@/components/ui/label/index.js'

export default {
  components: { Logo, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Input, Button, Label },
  data () {
    return {
      loading: false,
      errors: null,
      email: '',
      status: null
    }
  },
  methods: {
    async resetPassword () {
      if (this.loading) {
        return
      }

      this.errors = null
      this.loading = true
      this.status = null

      try {
        await axios.get('/sanctum/csrf-cookie')
        const response = await axios.post('/forgot-password', { email: this.email })
        this.status = response.data.message || this.$t('password_reset.link_sent')
      } catch (error) {
        this.errors = error.response?.data ?? { message: this.$t('password_reset.error') }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <div class="min-h-screen flex flex-col justify-center items-center gap-6 p-4">
    <Logo />
    <form class="w-full max-w-sm" @submit.prevent="resetPassword">
      <Card>
        <CardHeader>
          <CardTitle class="text-2xl">
            {{ $t('password_reset.forgot_title') }}
          </CardTitle>
          <CardDescription>{{ $t('password_reset.forgot_description') }}</CardDescription>
        </CardHeader>
        <CardContent class="grid gap-4">
          <p v-if="status" role="status" class="text-sm text-green-700 dark:text-green-400">
            {{ status }}
          </p>
          <div class="grid gap-2">
            <Label for="email">{{ $t('login.email') }}</Label>
            <Input id="email" v-model="email" type="email" name="email" autocomplete="email" required autofocus />
          </div>
          <div v-if="errors" role="alert" class="grid gap-1 text-sm text-destructive">
            <template v-if="errors.errors">
              <p v-for="(messages, field) in errors.errors" :key="field">
                {{ messages.join(' ') }}
              </p>
            </template>
            <p v-else>
              {{ errors.message }}
            </p>
          </div>
        </CardContent>
        <CardFooter class="flex flex-col gap-4">
          <Button block :loading="loading" type="submit">
            {{ $t('password_reset.send_link') }}
            <template #loading>
              {{ $t('password_reset.processing') }}
            </template>
          </Button>
          <router-link :to="{ name: 'Login' }" class="text-sm text-muted-foreground underline hover:text-foreground">
            {{ $t('password_reset.back_to_login') }}
          </router-link>
        </CardFooter>
      </Card>
    </form>
  </div>
</template>
